module.exports = __webpack_public_path__ + "6a788591fb3f9bded32bd422d75038fb.jpg";